export default __webpack_public_path__ + "static/media/alert-circle.7fdb7186.svg";